const normalizePath = (path: string): string =>
  path.trim().replace(/\/+$/, "") || "/";

export const isRouteActive = (pathname: string, path?: string): boolean => {
  if (!path) return false;

  const current = normalizePath(pathname);
  const target = normalizePath(path);

  if (target === "/") return current === "/";

  return current === target || current.startsWith(`${target}/`);
};
